/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import CDATA from 'Services/CDATA';
import classes from './Grid.module.scss';
import AppContext from 'AppContext';
import GrpToolbar from 'Library/GrpToolbar/GrpToolbar';
import GrpGrid from 'Library/GrpGrid/GrpGrid';
import GrpSpinner from 'Components/GrpSpinner/GrpSpinner';
import GrpError from 'Components/GrpError/GrpError';
import 'Styles/SCSS/ag-theme-material.scss';
import GrpButton from 'Library/GrpButton/GrpButton';

class ValidationExceptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      api_name: 'PRIIPS_app_validation_exception_summary',
      approvable: this.props.approvable,
      displayedRowCount: 0,
      // entity: this.props.entity,
      failed: false,
      // file_id: this.props.file_id,
      // file_name: this.props.file_name,
      // file_url: this.props.file_url,
      loading: true,
      mergeid: this.props.mergeid,
      // raw_api: this.props.raw_api,
      // table_name: this.props.table_name,
      totalRowCount: 0,
      trans_batch_id: this.props.trans_batch_id,
      toolbarButtons: [
        <GrpButton onClick={this.props.approve} size="Medium" type="Primary" text="Approve" />,
        <GrpButton onClick={this.props.reject} size="Medium" type="Primary" text="Reject" />,
      ],
    };
  }

  componentDidMount() {
    this.getMetadata();
  }

  async getMetadata() {
    try {
      const columns = await CDATA.makeRequest(
        'POST',
        'PRIIPS_app_GET_COLUMNS',
        '',
        {
          API_NAME: this.state.api_name,
          MERGE_QUEUE_ID: this.state.mergeid,
        },
        'Error retrieving column names and metadata.',
      );
      this.setState({ columnDefs: this.mapColumns(columns.value), rawColumns: columns.value });
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'We\'re sorry, there was an issue loading the columns for this table. Please try again. If the issue persists, contact your administrator.',
      });
      console.log(err);
    }
  }

  async getData() {
    try {
      this.gridApi.updateGridOptions({ rowData:[]});
      const data = await CDATA.makeRequest(
        'GET',
        this.state.api_name,
        CDATA.addFilter(`Client_Code eq '${this.context.state.selectedClient.code}' and TRANS_BATCH_ID eq ${this.state.trans_batch_id}`),
        {},
        'Error retrieving data.',
      );
      const totalRowCount = data && data['@odata.count'] !== 0 ? data['@odata.count'] : data.value.filter((item) => { return item.return_value !== '0'; }).length;
      const rowData = [];
      this.gridApi.forEachNode((node) => rowData.push(node.data));
      setTimeout(
        ()=>{
          if(JSON.stringify(rowData) !== JSON.stringify(data.value.filter((item) => item.return_value !== '0')))
            this.gridApi.updateGridOptions({ rowData: data.value.filter((item) => item.return_value !== '0')});
        }
      ,10);
      this.setState({ loading: false, totalRowCount });
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'We\'re sorry, there was an issue loading this data. Please try again. If the issue persists, contact your administrator.',
      });
    }
  }

  mapColumns = (rawColumns) => rawColumns.map((x) => ({
    field: x.dv_column,
    headerName: x.display_name,
    hide: x.is_hidden,
    editable: false,
    wrapText: true,
    autoHeight: true,
    comparator: x.sorttype !== undefined && x.sorttype.toLowerCase() === 'numeric' && ((value1, value2) => (value1 - value2)),
    // this is if you want to do a default sort for a specific column
    // sort: this.props.defaultGridSort !== undefined && this.props.defaultGridSort.toLowerCase() === x.dv_column.toLowerCase() ? {
    //   direction: 'desc',
    //   priority: 0
    // } : null,
  }));

  onGridReady = async (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    await this.getData();
  };

  onModelUpdated = (params) => {
    if(this.state.displayedRowCount !== params.api.getDisplayedRowCount())
      this.setState({ displayedRowCount: params.api.getDisplayedRowCount() });
  }

  render() {
    return (
      <div className={classes.Grid}>
        <div className={classes.GridBody}>
          {
            this.state.failed ? <GrpError text={this.state.failMessage} /> : (
              <>
                {
                  this.state.loading ? <GrpSpinner text="Loading data..." /> : (
                    this.gridApi && (
                      <GrpToolbar
                        api={this.gridApi}
                        working={this.state.toolbarWorking}
                        exportName={this.state.api_name}
                        controls={this.state.approvable ? this.state.toolbarButtons : null}
                        count={{
                          total: this.state.totalRowCount,
                          showing: this.state.displayedRowCount,
                        }}
                      />
                    )
                  )
                }

                <GrpGrid
                  apiName={this.state.api_name}
                  columnDefs={this.state.columnDefs}
                  externalFilter={this.doesExternalFilterPass}
                  onGridReady={this.onGridReady}
                  onModelUpdated={this.onModelUpdated}
                  pivotable
                  rawColumnData={this.state.rawColumns}
                />
              </>
            )
          }
        </div>
      </div>
    );
  }
}

ValidationExceptions.contextType = AppContext;

export default ValidationExceptions;
